import isArray from 'lodash/isArray';
import CustomBadge from '../CustomBadge';

function BadgeList(props: { rowObject: { tags: Array<{ color: string; name: string; tagValue: string }> } }) {
  if (props.rowObject.tags == null) return null;

  const tags = isArray(props.rowObject.tags)
    ? props.rowObject.tags
    : Object.entries(props.rowObject.tags).map(([key, value]) => ({
        tagValue: (
          <>
            <em className="font-normal">{key}: </em>
            <span className="ml-0.5">{value ?? '---'}</span>
          </>
        ),
        name: key,
        color: '#4e7184',
      }));

  if (!tags || tags.length === 0) return null;

  return (
    <div className="d-flex align-items-center gap-1 flex-wrap">
      {tags.map((t, i) => (
        <CustomBadge key={i} color={t.color}>
          {t.tagValue || t.name}
        </CustomBadge>
      ))}
    </div>
  );
}

export default BadgeList;
